import { toDataURL } from 'qrcode';

/**
 * ### generateQrCodeDataUrl
 *
 * @description
 * Generates a QR code data URL from a given URL string
 *
 * @param url - The URL to encode in the QR code
 * @returns Promise resolving to a data URL string for the QR code image
 * @throws Error if QR code generation fails
 */
export const generateQrCodeDataUrl = async (url: string): Promise<string> => {
  if (!url) {
    throw new Error('URL is required to generate QR code');
  }

  try {
    const dataUrl: string = await toDataURL(url);
    return dataUrl;
  } catch (error) {
    throw new Error(
      `Failed to generate QR code: ${error instanceof Error ? error.message : 'Unknown error'}`,
    );
  }
};
